import { render, staticRenderFns } from "./products-slider.vue?vue&type=template&id=531fca24&scoped=true&"
import script from "./products-slider.vue?vue&type=script&lang=js&"
export * from "./products-slider.vue?vue&type=script&lang=js&"
import style0 from "./products-slider.vue?vue&type=style&index=0&id=531fca24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531fca24",
  null
  
)

export default component.exports